module.exports = __webpack_public_path__ + "static/img/icon_listen.a080b63b.png";